function clearCartAndAddProduct(variantId,quantity,variantAttribute, sellingPlan = null) {
    const data = {
      quantity: 1,
      id: variantId,
      properties: {
        'Tickets': variantAttribute
      }
    }
  if (sellingPlan) {
    data.selling_plan = sellingPlan;
    data.properties['__subscription'] = sellingPlan;
  }
    $.ajax({
      type: 'POST',
      url: '/cart/clear.js',
      dataType: 'json',
      success: function() {
        console.log('Cart cleared');
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data,
          dataType: 'json',
          success: function() {
            console.log('Product added to cart');
             window.location.href ="/checkout"
          },
          error: function() {
            console.error('Error adding product to cart');
          }
        });
      },
      error: function() {
        console.error('Error clearing cart');
      }
    });
  }


$(document).ready(function () {
//   var avalableScroll = $("#unwevering").length;
// if (avalableScroll == 1) {
//   var a = 0;
//   $(window).scroll(function () {
//     var oTop = $("#unwevering").offset().top - window.innerHeight;
//     if (a == 0 && $(window).scrollTop() > oTop) {
//       $(".count_number").each(function () {
//         var $this = $(this),
//           countTo = $this.attr("data-count");
//         $({
//           countNum: $this.text(),
//         }).animate(
//           {
//             countNum: countTo,
//           },
//           {
//             duration: 4000,
//             easing: "swing",
//             step: function () {
//               $this.text(commaSeparateNumber(Math.floor(this.countNum)));
//             },
//             complete: function () {
//               $this.text(commaSeparateNumber(this.countNum));
//               //alert('finished');
//             },
//           }
//         );
//       });
//       a = 1;
//     }
//     if (a == 1 && $(window).scrollTop() < oTop) {
//       a = 0;
//     }
//   });

//   function commaSeparateNumber(val) {
//     while (/(\d+)(\d{3})/.test(val.toString())) {
//       val = val.toString().replace(/(\d+)(\d{3})/, "$1" + "," + "$2");
//     }
//     return val;
//   }
// }
  $(document).on("click", ".faq-title", function () { 
    $(this).parents('.faq-items-wrapper').siblings('.faq-items-wrapper').find('.faq-title').removeClass("active");
    $(this).toggleClass("active");
    $(this).parents('.faq-items-wrapper').siblings('.faq-items-wrapper').find('.accordion__content').slideUp();
    $(this).next(".accordion__content").slideToggle();   
  });
  
  $('.product-card-wrapper .buy-button:not(.competition_ended) .button').on('click', function() {
    $('.product-card-wrapper .buy-button:not(.competition_ended) .button').addClass('disabled');
    var variantId =  $(this).attr('data-variant');
    var VarAttribute =  $(this).attr('data-tickets');
     var quantity = 1;
    //code added for the purpose of selling plans on May 2025
    var sellingPlan = $(this).attr("data-selling-plan");
    clearCartAndAddProduct(variantId,quantity,VarAttribute, sellingPlan);
    
  });
  
  $('.video_text-btn').on('click', function() {
    $(this).parents('.row').find('video').trigger("play");
    $(this).parents(".row").find(".cover_image").hide();
    $(this).parents(".video-items .slide__item").siblings().find(".video-cover video").trigger("pause");
    $(this).parents(".video-items .slide__item").siblings().find(".video-cover .cover_image").show();
  });

  $(document).on("click", ".video-cover .cover_image .play-btn", function () {
    $(this).parents(".video-cover").find("video").trigger("play");
    $(this).parents(".video-cover").find(".cover_image").hide();
    $(this).parents(".video-items .slide__item").siblings().find(".video-cover video").trigger("pause");
    $(this).parents(".video-items .slide__item").siblings().find(".video-cover .cover_image").show();
  });
  
  $(".slideShow-wrapper").slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: true,
    prevArrow:
      '<button type="button" class="slick-prev"><svg width="30" height="47" viewBox="0 0 30 47" fill="none" xmlns="http://www.w3.org/2000/svg"><g filter="url(#filter0_d_393_3112)"><path d="M24 1.80481L7 20.897L24 37.6608" stroke="white" stroke-width="3" shape-rendering="crispEdges"/></g><defs><filter id="filter0_d_393_3112" x="0.931763" y="0.807251" width="28.1885" height="45.9216" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dy="4"/><feGaussianBlur stdDeviation="2"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.48 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_393_3112"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_393_3112" result="shape"/></filter></defs></svg></button>',
    nextArrow:
      '<button type="button" class="slick-next"><svg width="30" height="47" viewBox="0 0 30 47" fill="none" xmlns="http://www.w3.org/2000/svg"><g filter="url(#filter0_d_393_3111)"><path d="M6 1.3241L23 20.4163L6 37.1801" stroke="white" stroke-width="3" shape-rendering="crispEdges"/></g><defs><filter id="filter0_d_393_3111" x="0.879639" y="0.326538" width="28.1885" height="45.9216" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dy="4"/><feGaussianBlur stdDeviation="2"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.44 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_393_3111"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_393_3111" result="shape"/></filter></defs></svg></button>',
    adaptiveHeight: true,
  });
  /********************video slider*************************/

    $('.video-slider').slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows:true,
    dots: true,
    autoplay:false,
    prevArrow:'<button type="button" class="slick-prev"><svg width="30" height="47" viewBox="0 0 30 47" fill="none" xmlns="http://www.w3.org/2000/svg"><g filter="url(#filter0_d_393_3112)"><path d="M24 1.80481L7 20.897L24 37.6608" stroke="white" stroke-width="3" shape-rendering="crispEdges"/></g><defs><filter id="filter0_d_393_3112" x="0.931763" y="0.807251" width="28.1885" height="45.9216" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dy="4"/><feGaussianBlur stdDeviation="2"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.48 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_393_3112"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_393_3112" result="shape"/></filter></defs></svg></button>',
    nextArrow:'<button type="button" class="slick-next"><svg width="30" height="47" viewBox="0 0 30 47" fill="none" xmlns="http://www.w3.org/2000/svg"><g filter="url(#filter0_d_393_3111)"><path d="M6 1.3241L23 20.4163L6 37.1801" stroke="white" stroke-width="3" shape-rendering="crispEdges"/></g><defs><filter id="filter0_d_393_3111" x="0.879639" y="0.326538" width="28.1885" height="45.9216" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dy="4"/><feGaussianBlur stdDeviation="2"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.44 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_393_3111"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_393_3111" result="shape"/></filter></defs></svg></button>'
    });    

    $(document).on("click", ".term-title", function (evnt) {    
      evnt.preventDefault();
      var scrolldiv = $(this).attr("dataScroll");
      console.log(scrolldiv);
      $(this).parents('.term-item-wrapper').siblings('.term-item-wrapper').find('.term-title').removeClass("active");
      $(this).toggleClass("active");
      $(this).parents('.term-item-wrapper').siblings('.term-item-wrapper').find('.accordion__content').slideUp();
      $(this).next(".term-content").slideToggle();    
      setTimeout(function () {
        $('body,html').animate({
           scrollTop: $(".term-title[datascroll='" +scrolldiv+ "']").offset().top - 185
        }, 1000);   
      },500) 
    });
  
});

$(document).ready(function () {
  var currentURL = window.location.href;
  // if (currentURL.includes("product")) {
  //     window.location.href = "/pages/tickets";
  // }  
  if (currentURL.includes("cart")) {
      window.location.href = "/pages/tickets";
  } 
  if (currentURL.includes("collections")) {
      window.location.href = "/pages/tickets";
  }
  // if (currentURL.includes("account")) {
  //     window.location.href = "/pages/tickets";
  // }
});
 
/******************17-10-2023**************************/
$(document).ready(function() {
    $("a").removeAttr("title");
});